import React from 'react';

const StepNavigation = ({ currentStep, onStepClick }) => {
  const steps = [
    { number: 1, label: 'Design', icon: '🎨' },
    { number: 2, label: 'Background', icon: '�' },
    { number: 3, label: 'Upload', icon: '📸' },
    { number: 4, label: 'Personalize', icon: '✨' },
    { number: 5, label: 'Generate', icon: '🚀' }
  ];

  return (
    <div className="step-navigation">
      {steps.map((step) => (
        <div
          key={step.number}
          className={`step ${
            currentStep === step.number
              ? 'active'
              : currentStep > step.number
              ? 'completed'
              : 'disabled'
          }`}
          onClick={() => currentStep >= step.number && onStepClick(step.number)}
        >
          <div className="step-number">
            {currentStep > step.number ? '✓' : step.number}
          </div>
          <span className="step-label">{step.label}</span>
        </div>
      ))}
    </div>
  );
};

export default StepNavigation;
